import { SelectField } from '@/components/form/SelectField';
import { useLoader } from '@/hooks/useLoader';
import { loadActiveTeams } from './members';

/**
 * Équipe d'un nouvel employé, facultative : sans équipe, il ne peut pas créer sa feuille d'heures. Il y entre comme
 * équipier ; le nommer manager se fait dans l'écran Équipes (un seul manager par équipe).
 */
export function TeamField({
  id,
  companyId,
  value,
  onChange,
}: {
  id: string;
  companyId: number | null;
  value: number | null;
  onChange: (teamId: number | null) => void;
}) {
  const { data: teams } = useLoader(companyId ? String(companyId) : null, loadActiveTeams);

  return (
    <SelectField
      id={id}
      label="Équipe"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      hint="Il y entre comme équipier ; pour le nommer manager : écran Équipes."
    >
      <option value="">Aucune</option>
      {teams?.map((team) => (
        <option key={team.id} value={team.id}>
          {team.name}
        </option>
      ))}
    </SelectField>
  );
}
